
<template>
    
        <mars-view class="form-content-box"><mars-view v-if="isShowClose" class="title-close" @click.native.stop="close"><mars-view class="close"></mars-view></mars-view><mars-view v-for="item,index in info" :key="index"><mars-view v-if="item.element_type === 'title'" :id="item.element_type" class="clue-title">{{ item.title }}</mars-view><mars-view v-if="item.element_type === 'subtitle'" :id="item.element_type" class="clue-subtitle">{{ item.subtitle }}</mars-view><mars-view v-if="item.element_type === 'domainV2'" :id="item.element_type"><type-select :cur-type="curType" :select-type="item.domainV2 === 'relaxed_show' ? 'all' : 'more'" @typeSelect="typeChange"></type-select></mars-view><mars-view v-if="item.element_type === 'describe'" :id="item.element_type"><mars-view class="question-desc-box"><mars-view class="item-title">问题描述<mars-view class="require-icon"></mars-view></mars-view><mars-textarea :value="desc" placeholder="请描述您的问题" placeholder-style="color:B7B9C1;" class="info-desc textarea-content" :maxlength="500" :adjust-position="false" :show-confirm-bar="false" @input="descChange"></mars-textarea></mars-view></mars-view><mars-view v-if="item.element_type === 'name'" :id="item.element_type"><mars-view class="nickname-box"><mars-view class="item-title">称呼<mars-view class="require-icon"></mars-view></mars-view><mars-input v-model="uname" class="info-desc nick-input" placeholder="请输入您的称呼" placeholder-style="color: #b7b9c1;" :maxlength="20" :cursor-spacing="50" @input="nameChang"></mars-input></mars-view></mars-view><mars-view v-if="item.element_type === 'phone'" :id="item.element_type"><mars-view class="phone-select"><mars-view class="item-title">电话<mars-view class="require-icon"></mars-view></mars-view><mars-view :class="['info-desc', phone ? 'has-phone' : 'no-phone']" @click.native="handleCheck('isShowPhoneSelect')">{{ phone || '请输入手机号' }}</mars-view></mars-view></mars-view><mars-view v-if="item.element_type === 'user_protocol'" :id="item.element_type"><mars-view class="protocol-box"><mars-view class="protocol-commom" @click.native="handleCheck('agreementApply')"><mars-view class="protocol-checkbox" :class="agreementApply ? 'protocol-checkbox-check' : 'protocol-checkbox-uncheck'"></mars-view><mars-view>
                        同意
                        <mars-text class="protocol-desc" @click.native.stop="tapFn('userServeRules')">《咨询服务协议》</mars-text>
                        及<mars-text class="protocol-desc" @click.native.stop="tapFn('userPrivacyRules')">《隐私政策》</mars-text></mars-view></mars-view><mars-view class="protocol-commom extra-protocol" @click.native="handleCheck('tpApply')"><mars-view class="protocol-checkbox" :class="tpApply ? 'protocol-checkbox-check' : 'protocol-checkbox-uncheck'"></mars-view><mars-view>
                        免费获得额外3家
                        <mars-text class="protocol-desc" @click.native.stop="handleCheck('isShowTpApply')"> 法律服务方 </mars-text> 致电
                    </mars-view></mars-view></mars-view></mars-view><mars-view v-if="item.element_type === 'under_button'" :id="item.element_type"><mars-view :class="item.button_show === 'constant' ? 'fixed-submitBox' : 'submit-box'"><mars-view id="submit-btn" class="submit-btn" :style="{
                        backgroundColor: btnInfo.button_color || '#0054fd',
                        color: btnInfo.content_color || '#fff',
                    }" @click.native="submitForm"><div class="submit-title">{{ btnInfo.content }}</div></mars-view></mars-view></mars-view></mars-view><more-service-institution :is-show="isShowTpApply" @close="handleCheck('isShowTpApply')"></more-service-institution><phone-select :is-show="isShowPhoneSelect" @close="handleCheck('isShowPhoneSelect')" @phoneChange="phoneChange"></phone-select></mars-view>
    
</template>

<script>
import log from '../../../static/utils/ubcLog';
import { reqPathTo } from '../../../static/utils/env';
import { nav } from '../../../static/utils/navigate';
import { request } from '../../../static/utils/request';
import typeSelect from "./typeSelect.vue";
import moreServiceInstitution from "../../../components/clue/moreServiceInstitution.vue";
import phoneSelect from "../../../components/clue/phoneSelect.vue";
import { inSightObserverDisconnects, inSightObservers } from '../../../common/js/repeatExposureLog.js';
import Observer from '../../../common/js/observer.js';
export default {
  props: {
    // 类型选择--种类（展开全部&收缩）
    selectType: {
      type: String,
      default: ''
    },
    // 标题
    clueTitle: {
      type: String,
      default: ''
    },
    // 配置信息
    info: {
      type: Array,
      default: () => []
    },
    // url信息
    queryInfo: {
      type: Object,
      default: () => {}
    },
    // 表单提交-信息
    formInfo: {
      type: Object,
      default: () => {}
    },
    // 是否展示关闭按钮 默认-展示
    isShowClose: {
      type: Boolean,
      default: true
    },
    partFrom: {
      type: String,
      default: ''
    },
    // 组件类型
    comType: {
      type: String,
      default: ''
    },
    optype: {
      type: String,
      default: ''
    },
    isBtnBottom: {
      type: Boolean,
      default: true
    }
  },
  components: {
    'more-service-institution': moreServiceInstitution,
    'phone-select': phoneSelect,
    'type-select': typeSelect
  },
  computed: {
    // 是否允许提交
    // allowSubmit() {
    //     return this.curType && this.uname && this.phone && this.agreementApply && this.tpApply;
    // },
    // 按钮配置信息
    btnInfo() {
      let obj = null;
      this.info.forEach(item => {
        if (item.element_type === 'under_button') {
          obj = item.button;
        }
      });
      return obj || {};
    },
    from() {
      return this.optype || '';
    }
  },
  watch: {
    formInfo: {
      handler(newVal) {
        this.phone = newVal.phone || '';
        this.checkCode = newVal.checkCode || '';
        this.uname = newVal.uname || '';
        this.curType = newVal.type || '';
        this.encrypedPhone = newVal.encrypedPhone || '';
        this.desc = newVal.desc || '';
        this.agreementApply = newVal.agreementApply;
        this.tpApply = newVal.tpApply;
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      // 电话
      phone: '',
      // 验证码
      checkCode: '',
      // 称呼
      uname: '',
      styleType: false,
      // 问题描述
      desc: '',
      encrypedPhone: '',
      // 同意免费获额外
      tpApply: true,
      // 法律服务机构弹窗
      applyPhone: false,
      // 同意隐私
      agreementApply: true,
      isShowTpApply: false,
      isShowPhoneSelect: false,
      // 当前类型
      curType: '',
      isSwan: "h5" === 'swan'
    };
  },
  mounted() {
    if (this.comType === 'form_sub_new') {
      this.$nextTick(() => {
        this.addBtnObserver();
      });
    }
  },
  methods: {
    /**
     * 点击查看协议跳转
     * @param {type} string 协议类型名称
     * @return {void}
     */

    tapFn(type) {
      if (!type) {
        return;
      }
      nav({
        type: 'nav',
        url: '/pages/static/' + type
      });
    },
    /**
     * dom监听
     */

    addBtnObserver() {
      inSightObservers('#submit-btn', '', {}, [], true, true, false, {
        cb: res => {
          if (this.isSwan) {
            if (res && res.intersectionRect && res.intersectionRect.height > 0) {
              Observer.notify('isFormBtnShow', true);
            } else {
              Observer.notify('isFormBtnShow', false);
            }
          } else {
            if (res && res.intersectionRatio > 0.75) {
              Observer.notify('isFormBtnShow', true);
            } else {
              Observer.notify('isFormBtnShow', false);
            }
          }
        }
      });
    },
    /**
     * 关闭弹窗
     * @param {string} type 类型
     */

    handleCheck(type) {
      if (type === 'agreementApply' || type === 'tpApply') {
        this.$emit('formChange', {
          type,
          info: {
            value: !this[type]
          }
        });
        return;
      }
      this[type] = !this[type];
    },
    /**
     * 电话修改
     * @param {object} info 电话信息
     */

    phoneChange(info = {}) {
      this.$emit('formChange', {
        type: 'phone',
        info
      });
    },
    /**
     * 类型修改
     * @param {object} item
     */

    typeChange(item) {
      if (!item || !item.value || this.curType === item.value) {
        return;
      }
      this.$emit('formChange', {
        type: 'type',
        info: {
          type: item.value
        }
      });
    },
    /**
     * 问题描述切换
     */

    descChange(e) {
      let desc = e && e.detail && e.detail.value || '';
      this.$emit('formChange', {
        type: 'desc',
        info: {
          desc
        }
      });
    },
    /**
     * 名称切换
     */

    nameChang(e) {
      let uname = e && e.detail && e.detail.value || '';
      this.$emit('formChange', {
        type: 'uname',
        info: {
          uname
        }
      });
    },
    /**
     * 提交form表单事件
     * @return {void}
     */

    submitForm() {
      let {
        curType,
        phone,
        uname,
        encrypedPhone,
        desc
      } = this;
      let str = '';
      // 可自定义变化表单元素顺序，需要对提示文案进行排序
      let originArr = ['domainV2', 'describe', 'name', 'phone', 'user_protocol'];
      let sortArr = [];
      for (let i = 0; i < this.info.length; i++) {
        if (originArr.indexOf(this.info[i].element_type) !== -1) {
          sortArr.push(this.info[i].element_type);
        }
      }
      for (let i = 0; i < sortArr.length; i++) {
        if (sortArr[i] === 'domainV2') {
          if (!curType) {
            str = '请填写咨询信息';
            break;
          }
        } else if (sortArr[i] === 'describe') {
          if (!desc) {
            str = '请填写问题描述信息';
            break;
          } else if (desc && desc.length < 10) {
            str = '问题描述字数不少于10个';
            break;
          }
        } else if (sortArr[i] === 'name') {
          if (!uname) {
            str = '请填写称呼信息';
            break;
          }
        } else if (sortArr[i] === 'phone') {
          if (!phone) {
            str = '请填写电话信息';
            break;
          }
        }
      }
      if (str) {
        this.$api.showToast({
          title: str,
          icon: 'none'
        });
        return;
      }
      if (sortArr.indexOf('name') !== -1 && uname && uname.length > 20) {
        this.$api.showToast({
          title: '称呼信息不能超过20个字',
          icon: 'none'
        });
        return;
      }
      if (sortArr.indexOf('user_protocol') !== -1) {
        if (!this.agreementApply) {
          this.$api.showToast({
            title: '请阅读并同意相关协议',
            icon: 'none'
          });
          return;
        }
        if (!this.tpApply) {
          this.$api.showToast({
            title: '请同意额外服务方致电',
            icon: 'none'
          });
          return;
        }
      }
      this.$api.showLoading({
        title: '表单提交中',
        mask: true
      });
      log.send({
        serverId: 17260,
        area: 'biaodan-retention',
        action: 'click',
        optype: this.from
      });
      let {
        mapshowtag1 = '',
        mapcity = '',
        cuid = ''
      } = this.queryInfo || {};
      const params = {
        showtag: mapshowtag1,
        mapcity,
        cuid,
        'user_phone': phone,
        uname: this.uname,
        'consult_area': curType,
        'approve_cnt': this.tpApply ? 3 : 0,
        'use_ori_phone': encrypedPhone === phone ? 1 : 0,
        'consult_content': desc,
        from: this.from,
        code: this.checkCode || ''
      };
      const url = reqPathTo('clue/add_clue', this.ctx, '', 'falv');
      request({
        url: url,
        data: params,
        method: 'post',
        loginNeeded: false,
        needBduss: true,
        header: {
          'content-type': 'application/x-www-form-urlencoded'
        }
      }).then(resp => {
        const data = resp && resp.data || {};
        this.$api.hideLoading();
        if (+data.status === 0) {
          this.$api.showToast({
            title: '提交成功',
            icon: 'none'
          });
          this.$emit('successSubmit');
        } else {
          this.$api.showToast({
            title: data.msg || '咨询登记失败～',
            icon: 'none'
          });
        }
      }).catch(() => {
        this.$api.hideLoading();
        this.$api.showToast({
          title: '咨询登记失败～',
          icon: 'none'
        });
      });
    },
    /**
     * 关闭
     */

    close() {
      this.$emit('close');
    }
  },
  activated() {
    (function () {
      if (this.comType === 'form_sub_new') {
        this.$nextTick(() => {
          this.addBtnObserver();
        });
      }
    }).call(this, this.$route.query);
  },
  deactivated() {
    (function () {
      this.comType === 'form_sub_new' && inSightObserverDisconnects('#submit-btn');
    }).call(this, this.$route.query);
  }
};
</script>

<style scoped>
.form-content-box {
  position: relative;
  padding: 4.35vw 4.11vw 7vw;
  background: #fff;
  border-radius: 0 8.05vw 0 0;
}
.form-content-box .item-title {
  display: flex;
  align-items: center;
  color: #1e1f24;
  font-family: PingFang SC;
  font-size: 4.11vw;
  font-style: normal;
  font-weight: 500;
  line-height: 1;
}
.form-content-box .item-title .require-icon {
  width: 1.93vw;
  height: 1.69vw;
  background: url('https://lvlin-base.cdn.bcebos.com/law/pages/mapClue/require-icon.png') no-repeat center / 100% 100%;
}
.form-content-box .clue-title {
  margin-bottom: 2.35vw;
  height: 4.35vw;
  line-height: 4.35vw;
  font-family: PingFangSC-Medium;
  text-align: center;
  font-size: 4.35vw;
  color: #000;
}
.form-content-box .clue-subtitle {
  margin-bottom: 4.83vw;
  height: 3.38vw;
  line-height: 3.38vw;
  font-family: PingFangSC-Regular;
  text-align: center;
  font-size: 3.38vw;
  color: #848691;
}
.form-content-box .title-close {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 5.14vw;
  height: 5.14vw;
  right: 3.11vw;
  top: 3.35vw;
}
.form-content-box .title-close .close {
  width: 3.14vw;
  height: 3.14vw;
  background-image: url('https://lvlin-base.cdn.bcebos.com/law/pages/clue-collection/clue-collection-popup-close-icon.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.form-content-box .info-desc {
  margin-top: 3.14vw;
  padding: 0 4.11vw;
  background: #f5f6f9;
  height: 12.08vw;
  color: #1e1f24;
  font-family: PingFang SC;
  font-size: 3.86vw;
  font-style: normal;
  font-weight: 400;
  line-height: 12.08vw;
  border-radius: 2.17vw;
  box-sizing: border-box;
}
.form-content-box .nickname-box {
  margin-top: 6.52vw;
}
.form-content-box .nickname-box .nick-input {
  outline: none;
}
.form-content-box .phone-select {
  margin-top: 6.52vw;
}
.form-content-box .phone-select .no-phone {
  color: #b7b9c1;
  font-weight: 400;
}
.form-content-box .question-desc-box {
  margin-top: 6.52vw;
}
.form-content-box .question-desc-box .textarea-content {
  width: 100%;
  height: 17.39vw;
  padding: 4.11vw;
  line-height: 6vw;
  border: 0;
  outline: 0;
  box-sizing: border-box;
}
.protocol-box {
  margin-top: 6.52vw;
  font-family: PingFangSC-Regular;
  font-size: 3.14vw;
  color: #848691;
  line-height: 3.14vw;
  font-weight: 400;
}
.protocol-box .protocol-commom {
  display: flex;
  align-items: center;
  margin-bottom: 0.13rem;
}
.protocol-box .protocol-commom.extra-protocol {
  margin-bottom: 0;
}
.protocol-box .protocol-commom .protocol-checkbox {
  width: 3.62vw;
  height: 3.62vw;
  margin-right: 1.77vw;
  border-radius: 50%;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.protocol-box .protocol-commom .protocol-checkbox-check {
  background-image: url('https://lvlin-base.cdn.bcebos.com/law/pages/mapClue/choiced.png');
}
.protocol-box .protocol-commom .protocol-checkbox-uncheck {
  background-image: url('https://lvlin-base.cdn.bcebos.com/law/pages/clue-collection/not-choiced-icon.png');
}
.protocol-box .protocol-commom .protocol-desc {
  color: #50525c;
}
.submit-box {
  margin-top: 6.52vw;
}
.submit-box .submit-btn {
  position: relative;
  overflow: hidden;
  height: 10.63vw;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: PingFang SC;
  font-weight: 500;
  background: #0054fd;
  color: #fff;
  border-radius: 0.22rem;
  border-top: 0.24vw solid #f5f6f9;
  box-sizing: border-box;
}
.submit-box .submit-btn .submit-title {
  text-align: center;
  font-size: 3.86vw;
  line-height: 1;
}
.submit-box .submit-btn.disabled {
  background: rgba(0, 84, 253, 0.1);
}
.fixed-submitBox {
  position: fixed;
  width: 100%;
  display: flex;
  height: 13.53vw;
  justify-content: center;
  border-top: 0.24vw solid #f5f6f9;
  background-color: #fff;
  bottom: 0;
  left: 0;
  z-index: 10;
  padding-bottom: constant(safe-area-inset-bottom);
  /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom);
  /* 兼容 iOS >= 11.2 */
}
.fixed-submitBox .submit-btn {
  flex: 1;
  height: 9.66vw;
  margin: 1.93vw 4.51vw 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: PingFang SC;
  font-weight: 500;
  background: #0054fd;
  color: #fff;
  border-radius: 0.22rem;
  border-top: 0.24vw solid #f5f6f9;
  box-sizing: border-box;
}
.fixed-submitBox .submit-btn .submit-title {
  text-align: center;
  font-size: 3.86vw;
  line-height: 1;
}
.fixed-submitBox .submit-btn.disabled {
  background: rgba(0, 84, 253, 0.1);
}

</style>
